export default __webpack_public_path__ + "img/cLZBVvIs.54d74287.svg";